export default function ComoFunciona() {
  const steps = [
    {
      number: '01',
      icon: 'ri-phone-line',
      title: 'Cliente Llama',
      description: 'Desde cualquier telefono, tableta o computadora por WEBCALL® o a un número telefónico.'
    },
    {
      number: '02',
      icon: 'ri-brain-line',
      title: 'Tu Agente toma la llamada en menos de 5 segundos',
      description: 'Aumenta en 400% tu posibilidad de negocio al contestar en el instante.'
    },
    {
      number: '03',
      icon: 'ri-message-3-line',
      title: 'Respuesta Inteligente',
      description: 'El agente genera una respuesta contextual y personalizada basada en tu base de conocimientos.'
    },
    {
      number: '04',
      icon: 'ri-checkbox-circle-line',
      title: 'Problema o Cita en tu agenda',
      description: 'El Agente puede ver tu agenda, hacer la cita y enviar un email a tu cliente con la confirmación.'
    }
  ];

  return (
    <section id="como-funciona" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-[#0a0e27] to-[#1a1f3a] relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, cyan 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-cyan-400 text-xs sm:text-sm font-bold tracking-widest mb-3 sm:mb-4 uppercase">TECNOLOGÍA AVANZADA</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-4 px-4">
            Cómo Funciona Nuestro
            <br />
            <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
              Agente Inteligente
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="group relative">
              <div className="relative bg-gradient-to-br from-[#1a1f3a] to-[#0a0e27] p-6 sm:p-8 rounded-2xl border border-cyan-500/20 hover:border-cyan-500/60 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/20 h-full">
                <div className="absolute top-0 right-0 w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-cyan-500/10 to-transparent rounded-bl-3xl"></div>
                
                <div className="mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-r from-cyan-500/20 to-purple-600/20 flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                    <span className="text-xl sm:text-2xl font-bold text-cyan-400">{step.number}</span>
                  </div>
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center">
                    <i className={`${step.icon} text-3xl sm:text-4xl text-cyan-400 group-hover:text-cyan-300 transition-colors duration-300`}></i>
                  </div>
                </div>

                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 sm:mb-3">{step.title}</h3>
                <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{step.description}</p>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-20">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-cyan-500/50 to-transparent"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
